import * as types from './mutation-types'

export const loadTicketTypes = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/'+id+'/eventTicketType/collection' ).then((response) => {
            commit(types.LOAD_TICKET_TYPES, response.data.data) 
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const saleTicket = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`store/ticket/sale`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadEventSalesStats = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/event/'+id+'/ticket/sales/statistics' ).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
 
